module.exports = __webpack_public_path__ + "static/curem-7f194ebc1c9f13490a845c98ab894f70.webm";